__turbopack_context__.v({
  "card": "DNDIKa_card",
});
